import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import classNames from 'classnames'
import {List} from 'immutable'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import IconKeyboardArrowLeft from 'material-ui-icons/KeyboardArrowLeft'
import IconKeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight'

import moment from '../../../common/moment'

const columnWidth = 14.28

const styles = theme => ({
  container: {
    margin: '0 auto',
    width: 245,
  },
  monthContainer: {
    display: 'flex',
  },
  arrow: {
    height: 35, width: 35, padding: 5,
  },
  month: {
    flex: 1,
    padding: 7,
    textAlign: 'center',
    fontSize: '1rem',
    marginBottom: 10,
  },
  weekDaysContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  weekDay: {
    width: columnWidth + '%',
    textAlign: 'center',
    fontSize: '.75rem',
  },
  daysContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  day: {
    width: columnWidth + '%',
    textAlign: 'center',
    fontSize: '.75rem',
  },
  dayButton: {
    height: 35,
    width: 35,
    padding: 5,
    fontSize: '.75rem',
    margin: '0 auto',
    transition: 'none',
  },
  selectedDayButton: {
    background: theme.palette.primary.main,
    color: 'white',
  },
  onlyDayButton: {
    borderRadius: '50%',
  },
  firstDayButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  lastDayButton: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  middleDayButton: {
    borderRadius: 0,
  },
})

class Calendar extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      date: props.date.clone().date(1),
      selected: List(),
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      date: moment(props.date),
    })
  }

  selectDay = day => {
    const selected = this.state.selected
    let newList = List()
    switch (selected.size) {
      case 0:
        newList = selected.push(day)
        break
      case 1:
        if (day.isBefore(selected.get(0))) {
          newList = selected.set(0, day)
        } else {
          let date = selected.get(0)
          for (let i = 1; date.isBefore(day, 'day') || date.isSame(day, 'day'); i++) {
            newList = newList.push(date.clone())
            date.add(1, 'day')
          }
        }
        break
      default:
        if (day.isBefore(selected.get(0))) {
          newList = List([day])
        } else if (day.isBefore(selected.get(selected.size - 1))) {
          newList = List([day])
        } else {
          let date = selected.get(0)
          for (let i = 1; date.isBefore(day, 'day') || date.isSame(day, 'day'); i++) {
            newList = newList.push(date.clone())
            date.add(1, 'day')
          }
        }
    }
    this.setState({
      selected: newList,
    })
    this.props.onClick(newList.get(0), newList.get(newList.size - 1))
  }

  nextMonth = () => {
    this.setState({
      date: this.state.date.clone().add(1, 'month'),
    })
  }

  prevMonth = () => {
    this.setState({
      date: this.state.date.clone().add(-1, 'month'),
    })
  }

  getMonth = () => {
    const text = this.state.date.format('MMMM Y')
    return text.substr(0, 1).toUpperCase() + text.substring(1, text.length)
  }

  getWeekdays = () => {
    return moment.weekdaysShort().map(d => d.substr(0, 3))
  }

  getDaysOfTheMonth = () => {
    const days = []
    const month = this.state.date.clone().endOf('month')
    for (let i = 0; i < month.date(); i++) {
      days.push(this.state.date.clone().date(i + 1))
    }
    return days
  }

  getMarginOfFirstDay = () => {
    return this.state.date.format('d') * columnWidth
  }

  getDayButtonClass = (classes, size, index) => {
    if (index === -1) return ''
    if (size === 1) return classes.onlyDayButton
    if (index === 0) return classes.firstDayButton
    if (index === size - 1) return classes.lastDayButton
    return classes.middleDayButton
  }

  render() {
    const {classes} = this.props
    return (
      <div className={classes.container}>
        <div className={classes.monthContainer}>
          <IconButton className={classes.arrow} onClick={this.prevMonth}><IconKeyboardArrowLeft/></IconButton>
          <Typography className={classes.month}>{this.getMonth()}</Typography>
          <IconButton className={classes.arrow} onClick={this.nextMonth}><IconKeyboardArrowRight/></IconButton>
        </div>
        <div className={classes.weekDaysContainer}>
          {this.getWeekdays().map(d => <Typography key={d} className={classes.weekDay}>{d.toUpperCase()}</Typography>)}
        </div>
        <div className={classes.daysContainer}>
          {this.getDaysOfTheMonth().map((d, k) => {

            let style = {}
            if (k === 0) style.marginLeft = this.getMarginOfFirstDay() + '%'

            const index = this.state.selected.findIndex(a => a.isSame(d, 'day'))
            const buttonClass = this.getDayButtonClass(classes, this.state.selected.size, index)

            return (
              <div key={k} className={classes.day} style={style}>
                <IconButton
                  className={classNames(
                    classes.dayButton,
                    {
                      [buttonClass]: buttonClass,
                      [classes.selectedDayButton]: buttonClass,
                    },
                  )}
                  onClick={() => this.selectDay(d)}
                >
                  {d.format('D')}
                </IconButton>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  static propTypes = {
    date: PropTypes.object,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    date: moment().date(1),
    onClick: () => {},
  }
}

export default withStyles(styles, {withTheme: true})(Calendar)



// WEBPACK FOOTER //
// ./src/sections/rent/components/calendar.jsx